import { useSelector } from 'react-redux';
import { Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import { CustomAvatar } from '@app/components/custom-avatar';
import { StatusTag } from '@app/components';
import { EmployeeStatus, Strings } from '@app/constants';
import { TableCellCustom } from '@app/components/table';
import { IEmployee } from '../types';
import { RowActions } from './row-actions';
import { selectRoleState } from '@app/modules/role';
import { PATH_DASHBOARD } from '@app/routes/paths';
import { selectEmployeesState } from '../selectors';
import { useAuthRole } from '@app/utils';

interface Props {
  row: IEmployee;
  selected: boolean;
  onSelectRow: VoidFunction;
}

const EmployeeRow = (props: Props) => {
  const { row } = props;
  const roleState = useSelector(selectRoleState);
  const roles = roleState.data?.records;
  const employeeState = useSelector(selectEmployeesState);
  const employees = employeeState?.data?.records;
  const { isSuperAdmin } = useAuthRole();

  const managerNames = row?.managerId
    ?.map((id) => {
      const numericId = parseInt(id, 10);
      return employees?.find((emp) => emp.id === numericId)?.firstName;
    })
    .filter(Boolean)
    .join(', ');

  const navigate = useNavigate();
  const handleDetails = () => {
    navigate(`${PATH_DASHBOARD.employeeDetail}/${row?.firstName}`, { state: { id: row?.id } });
  };
  let statusValue;
  if (row.status === Strings.status.inactive) {
    statusValue = EmployeeStatus.Inactive;
  } else {
    statusValue = EmployeeStatus.Active;
  }
  return (
    <>
      <TableCellCustom flex onClick={handleDetails} style={{ cursor: 'pointer' }} align="center">
        <Typography variant="body2">{row.id}</Typography>
      </TableCellCustom>
      <TableCellCustom
        onClick={handleDetails}
        style={{ cursor: 'pointer' }}
        align="center"
        width={200}
      >
        <Stack style={{ flexDirection: 'row', alignItems: 'center', gap: '9px' }}>
          <CustomAvatar
            name={`${row.firstName} ${row.lastName}`}
            color={row?.profileImage ? 'default' : 'info'}
            src={row?.profileImage}
            alt="pic"
          />
          <Typography variant="body2">
            {row.firstName} {row.lastName}
          </Typography>
        </Stack>
      </TableCellCustom>
      <TableCellCustom flex onClick={handleDetails} style={{ cursor: 'pointer' }} align="center">
        <Typography variant="body2">{row.email}</Typography>
      </TableCellCustom>
      <TableCellCustom flex onClick={handleDetails} style={{ cursor: 'pointer' }} align="center">
        <Typography variant="body2" width={'70px'}>
          {row.phone || 'NA'}
        </Typography>
      </TableCellCustom>
      <TableCellCustom flex onClick={handleDetails} style={{ cursor: 'pointer' }} align="center">
        {roles?.map((option, index) => (
          <Typography variant="body2" key={index} width={'60px'}>
            {row.roleId === 1 && index === 0
              ? option.name
              : row.roleId === option.id && option.name}
          </Typography>
        ))}
      </TableCellCustom>
      {isSuperAdmin && (
        <TableCellCustom flex onClick={handleDetails} style={{ cursor: 'pointer' }} align="center">
          <Typography variant="body2" width={'60px'}>
            {managerNames || 'NA'}
          </Typography>
        </TableCellCustom>
      )}
      <TableCellCustom flex onClick={handleDetails} style={{ cursor: 'pointer' }} align="center">
        <StatusTag status={EmployeeStatus[statusValue]} />
      </TableCellCustom>
      <TableCellCustom flex align="center">
        <RowActions row={row} />
      </TableCellCustom>
    </>
  );
};

export { EmployeeRow };
